'use client';
import { memo } from 'react';
import { Box, GridItem, HStack, Text, VStack } from '@chakra-ui/react';

import ProjectsCasesIllustration from 'shared/ProjectsCasesIllustration';
import CustomTags from 'shared/CustomProjectCasesCardsTags';
import CustomOverlayLink from 'shared/CustomOverlayLink';
import NextImage from 'shared/NextImage';

import { DEFAULT_BORDER } from 'constants/global';
import { PAGES_TYPES } from 'constants/pagesTypes';
import Arrow from 'assets/icons/Arrow45degGray.svg';

const BigProjectsCasesCard = ({
  companyLogo,
  companyLogoProps,
  domain,
  illustration,
  cardScreen,
  title,
  link,
  description = null,
}) => (
  <GridItem
    role="group"
    pos="relative"
    id="big"
    colSpan={2}
    display="flex"
    flexDir={{ mobile: 'column', tablet: 'row' }}
    w="full"
    minH={{ mobile: '473px', tablet: '330px', laptop: '510px', desktop: '570px' }}
    border={DEFAULT_BORDER}
    borderColor="line.gray"
    bgColor="#F5F7FA"
    borderRadius={{ mobile: '32px', laptop: '48px' }}
    gap={{ mobile: '28px', tablet: '24px', laptop: '48px' }}
    p={{ mobile: '12px 12px 28px', tablet: '12px 16px 12px 12px', laptop: '24px' }}
  >
    <CustomOverlayLink
      title="Перейти на страницу кейса"
      link={`/${PAGES_TYPES.cases}/${link}`}
      isExternal
    />

    <Box
      w="full"
      minH={{ mobile: '218px', tablet: 'full' }}
      pos="relative"
      borderRadius={{ mobile: '20px', laptop: '36px' }}
      overflow="hidden"
    >
      <ProjectsCasesIllustration
        h="full"
        align="center"
        justify="center"
        cardScreen={cardScreen}
        cardScreenProps={{ container: { w: 'clamp(273px, 35dvw, 495px)', pos: 'static' } }}
        illustration={illustration}
        imgProps={{ h: 'full' }}
        transition="transform 0.3s"
        _groupHover={{ transform: 'scale(1.1)' }}
      />
    </Box>

    <VStack
      w="full"
      maxW={{ laptop: '655px' }}
      align="start"
      gap={{ mobile: '24px', laptop: '32px', desktop: '24px' }}
      pr={{ laptop: '24px' }}
    >
      <CustomTags companyLogo={companyLogo} companyLogoProps={companyLogoProps} domain={domain} />

      <VStack
        boxSize="full"
        align="start"
        justify="space-between"
        gap={{ mobile: '16px', laptop: '32px' }}
      >
        <VStack w="full" align="start" gap={{ tablet: '12px', laptop: '24px', desktop: '18px' }}>
          <Text
            w="full"
            textStyle="header.h3"
            noOfLines={{ mobile: 2, laptop: 3 }}
            fontSize={{ mobile: '18px', tablet: '24px', laptop: '32px', desktop: '32px' }}
          >
            {title}
          </Text>

          {description && (
            <Text w="full" textStyle="h2" fontWeight="500" color="text.steelGray">
              {description}
            </Text>
          )}
        </VStack>

        <HStack
          w="full"
          minH={{ tablet: '40px' }}
          pr={{ tablet: '20px', laptop: 'unset' }}
          align="center"
          justify="space-between"
          opacity={{ mobile: '1', laptop: '0' }}
          transition="opacity .4s ease-out"
          _groupHover={{ opacity: { laptop: '1' } }}
          _groupFocusWithin={{ opacity: { laptop: '1' } }}
        >
          <Text textStyle="h1" fontWeight="500" color="text.steelGray">
            Подробнее
          </Text>

          <NextImage
            src={Arrow}
            alt="Иконка стрелки"
            w="auto"
            h="auto"
            boxSize={{ mobile: '36px', laptop: '57px' }}
          />
        </HStack>
      </VStack>
    </VStack>
  </GridItem>
);

export default memo(BigProjectsCasesCard);
